import Meals from './Meals'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as publicSelectors from '../../../selectors/public'
import * as orderSelectors from '../../../selectors/order'

import { addProduct, removeProduct } from '../../../store/actions/order'

const mapStateToProps = state => ({
  menu: publicSelectors.getMenu(state),
  isLoading: publicSelectors.menuLoading(state),
  order: orderSelectors.getOrder(state),
  selectedCategoryId: publicSelectors.getSelectedCategoryId(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addProduct,
      removeProduct
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Meals)



// WEBPACK FOOTER //
// ./src/modules/Menu/Meals/index.js